import { ComponentProps } from '@episerver/spa-core/EpiComponent';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import OlympicsIframeData from '../../../Models/Content/OlympicsIframeBlockData';
import React, { useEffect, useState } from 'react';
import { Col, Row, Container } from 'reactstrap';

const OlympicsIframe = (props) => {

  const [iframeUrl, setIframUrl] = useState('');

  useEffect(() => {
    const parameters = window.location.search;

    if (parameters) {     
      const query = new URLSearchParams(window.location.search);
      var idParameter = '';
      try {
        var idParameter = encodeURIComponent(decodeURIComponent(query.get('id')));
      }
      catch {
        var idParameter = query.get('id');
      }

      if (idParameter) {
        setIframUrl(`${props.data.link.value}?userBroadcasterForeignID=${idParameter}&broadcasterName=cellcom`);
      }
    }
  }, []);

  return (
    <div className="olympics">
      <Container>
        <iframe frameBorder='0' scrolling='no' className='olympics-iframe' src={iframeUrl} title=''></iframe>
      </Container>
    </div>
  );
};

export default OlympicsIframe;
